import React, { useState, useEffect, useRef } from "react";
import { Avatar, TextField, Grid, Paper, FormControlLabel, Checkbox, Typography, FormLabel, RadioGroup, Radio, FormControl, InputLabel, Select, MenuItem, Button, Backdrop, CircularProgress, Badge } from '@mui/material';
import { makeStyles } from '@mui/styles';
import InputMask from "react-input-mask";
import AdapterJalali from '@date-io/date-fns-jalali';
import DatePicker from '@mui/lab/DatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import axios from 'axios';
import { getAuthenticationToken } from '../utils/TokenHandler';
import MaterialNotifyComponent from "./MaterialNotifyComponent";
import { styled } from '@mui/material/styles';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { setUserProfile } from "../utils/userProfile";
import { withRouter } from 'react-router-dom';

function UserProfileForm(props) {
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    const [open, setOpen] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [isMarried, setIsMarried] = useState(false);
    const [sex, setSex] = useState(false);
    const [address, setAddress] = useState('');
    const [cityId, setCityId] = useState(null);
    const [provinceId, setProvinceId] = useState(null);
    const [guildId, setGuildId] = useState(null);
    const [nationalCode, setNationalCode] = useState('');
    const [birthCertificateNumber, setBirthCertificateNumber] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [birthDateValue, setBirthDateValue] = useState(new Date());
    const [dateOfMarriageValue, setDateOfMarriageValue] = useState(new Date());
    const [wifeOrHousbandBirthDateValue, setWifeOrHousbandBirthDateValue] = useState(new Date());
    const [customerInformation, setCustomerInformation] = useState({
        birthDate: new Date(),
        dateOfMarriage: new Date(),
        wifeOrHousbandBirthDate: new Date(),
        city: {
            province: {
                id: 0,
                name: ""
            },
            id: 0,
            name: "",
            zones: []
        },
    });
    const [entrieProviceAndCityAndZone, setEntrieProviceAndCityAndZone] = useState(null);
    const [cities, setCities] = useState(null);
    const [guilds, setGuilds] = useState(null);

    const getTrueDate = (inputDate) => {
        let d = new Date(inputDate);
        return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0)
    };

    const getDateWithoutTime = (inputDate) => `${inputDate.getFullYear()}/${inputDate.getMonth() + 1}/${inputDate.getDate()}`;

    const useStyles = makeStyles(theme => ({
        root: {
            "& .MuiFormLabel-root": {
                right: 0, // or black
                left: 'unset',
                color: '#ffffff'
            },
            "& .MuiInputLabel": {
                color: '#ffffff'
            },
            '& .MuiInput-root::after': {
                borderBottom: '2px solid #ffffff'
            },
            '& .MuiInputBase-input-MuiInput-input': {
                color: '#ffffff'
            },
            '& .Mui-focused': {
                color: '#ffffff !important'
            },
            '& .MuiInputBase-root': {
                color: '#ffffff !important'
            },
            '& .MuiInputBase-formControl': {
                marginRight: '25px'
            },
            "& .MuiSvgIcon-root": {
                right: 'unset', // or black
                left: 0,
                color: '#ffffff !important'
            },
            "& .MuiInputBase-inputAdornedEnd": {
                textAlign: 'center'
            },
        }
    }));

    const inputFile = useRef(null)

    const classes = useStyles();
    const formElementStyle = {
        margin: "10px 0",
        backgroundColor: '#0072bc'
    };
    const paperStyle = {
        padding: 20,
        height: 'max-content',
        width: '70vw',
        margin: 'auto'
    };
    const MenuItemStyle = { justifyContent: 'flex-end' };
    const avatarStyle = {
        width: '80px',
        height: '80px',
        backgroundColor: '#ffffff'
    };

    const SmallAvatar = styled(Avatar)(({ theme }) => ({
        width: 22,
        height: 22,
        border: `2px solid ${theme.palette.background.paper}`,
        background: '#012d50',
        padding: '4px',
        cursor: 'pointer'
    }));    

    const formButtonElementStyle = {
        margin: "10px 0",
        backgroundColor: '#014171',
        fontSize: 'x-large',
        boxShadow: '0px 10px 20px 5px rgba(255, 255, 255, 0.2)'
    };

    const footerButtonStyle = {
        display: 'inline-block',
        padding: '0px 20px',
        width: '50%'
    };

    const footerButtonContainerStyle = {
        display: 'flex',
        justifyContent: 'space-evenly',
        position: 'fixed', left: '0',
        bottom: '0', width: '100%',
        zIndex: '1'
    };

    const useRadioStyles = makeStyles({
        root: {
            '&.Mui-checked': {
                color: '#ffffff', // رنگ دایره انتخاب شده
            },
            '&.MuiRadio-colorPrimary': {
                color: '#ffffff !important',
            } // رنگ دایره انتخاب نشده
        },
    });

    function CustomRadio(props) {
        const radioItem = useRadioStyles();
        return <Radio className={radioItem.root} {...props} />;
    }

    useEffect(() => {
        setOpen(true);
        axios.get('api/v1/AdditionalData/GetEntrieProviceAndCityAndZone').then((res) => {
            setEntrieProviceAndCityAndZone(res.data);
            axios.get('api/v1/AdditionalData/GetGuilds').then((res) => {
                setGuilds(res.data);
                axios.get('api/v1/Profile/GetCustomerInformation', {
                    params: {
                        userId: getAuthenticationToken().userID
                    }
                }).then((response) => {
                    const res = response.data;
                    setCustomerInformation(res);
                    setProvinceId(res.city && res.city.province && res.city.province.id)
                    setBirthDateValue(getTrueDate(res.birthDate));
                    setDateOfMarriageValue(getTrueDate(res.dateOfMarriage));
                    setWifeOrHousbandBirthDateValue(getTrueDate(res.wifeOrHousbandBirthDate));
                    setFirstName(res.firstName);
                    setLastName(res.lastName);
                    setIsMarried(res.isMarried);
                    setSex(res.sex);
                    setAddress(res.address);
                    setNationalCode(res.nationalCode);
                    setBirthCertificateNumber(res.birthCertificateNumber);
                    setPostalCode(res.postalCode);
                    setCityId(res.cityId);
                    setGuildId(res.guildId);
                }).catch((e) => {
                    setMessageNotify({
                        severity: "error",
                        message: "خطا در فراخوانی اطلاعات از سرور",
                        open: true
                    });
                }).finally(() => {
                    setOpen(false);
                })
            }).catch((e) => {
                setMessageNotify({
                    severity: "error",
                    message: "خطا در فراخوانی اطلاعات از سرور",
                    open: true
                });
                setOpen(false);
            });
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در فراخوانی اطلاعات از سرور",
                open: true
            });
            setOpen(false);
        });
    }, []);

    useEffect(() => {
        if (provinceId) {
            const selectedProvice = entrieProviceAndCityAndZone && entrieProviceAndCityAndZone.filter(item => item.id === provinceId)[0].city;
            setCities(selectedProvice.map((item) => {
                return <MenuItem value={item.id} style={MenuItemStyle}>{item.name}</MenuItem>
            }));
        }
    }, [provinceId])

    const handleSubmit = (e) => {
        e.preventDefault();
        setOpen(true);
        axios.post('api/v1/Profile/WebUpdateCustomer', {
            id: getAuthenticationToken().userID,
            firstName: firstName,
            lastName: lastName,
            isMarried: isMarried,
            birthDate: getDateWithoutTime(birthDateValue),
            wifeOrHousbandBirthDate: getDateWithoutTime(wifeOrHousbandBirthDateValue),
            dateOfMarriage: getDateWithoutTime(dateOfMarriageValue),
            birthCertificateNumber: birthCertificateNumber,
            postalCode: postalCode,
            sex: sex,
            address: address,
            cityId: cityId,
            nationalCode: nationalCode,
            guildId: guildId
        }).then(response => {
            setMessageNotify({
                severity: "success",
                message: "اطلاعات با موفقیت ثبت شد",
                open: true
            });
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در ارسال اطلاعات به سرور",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        })
    }

    const openFileDialog = (e) => {
        inputFile.current.click();
    }

    const readAvatarFile = (e) => {
        setOpen(true);
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = function () {
            var imagebase64 = reader.result;
            axios.post('api/v1/Profile/AddOrUpdateCustomerProfileImageBase64', {
                profileImageAsBase64String: imagebase64.replace("data:image/jpeg;base64,", "").replace("data:image/png;base64,", ""),
                customerId: getAuthenticationToken().userID
            }).then((response) => {
                if (response.data) {
                    axios.get('api/v1/Profile/GetCustomerInformation', {
                        params: {
                            userId: getAuthenticationToken().userID
                        }
                    }).then((response) => {
                        const res = response.data;
                        setCustomerInformation(res);
                        setProvinceId(res.city && res.city.province && res.city.province.id)
                        setBirthDateValue(getTrueDate(res.birthDate));
                        setDateOfMarriageValue(getTrueDate(res.dateOfMarriage));
                        setWifeOrHousbandBirthDateValue(getTrueDate(res.wifeOrHousbandBirthDate));
                        setFirstName(res.firstName);
                        setLastName(res.lastName);
                        setIsMarried(res.isMarried);
                        setSex(res.sex);
                        setAddress(res.address);
                        setNationalCode(res.nationalCode);
                        setBirthCertificateNumber(res.birthCertificateNumber);
                        setPostalCode(res.postalCode);
                        setCityId(res.cityId);
                        setUserProfile({
                            customerUserName: res.userName,
                            customerName: `${res.firstName} ${res.lastName}`,
                            profileCDNImage: res.cdnImage,
                            customerType: res.customerType
                        });
                    }).catch((e) => {
                        setMessageNotify({
                            severity: "error",
                            message: "خطا در فراخوانی اطلاعات از سرور",
                            open: true
                        });
                    }).finally(() => {
                        setOpen(false);
                    })
                }
            }).catch((e) => {
                setMessageNotify({
                    severity: "error",
                    message: "خطا در ارسال اطلاعات به سرور",
                    open: true
                });
                setOpen(false);
            });
        }
        reader.readAsDataURL(file);
    }

    const provice = entrieProviceAndCityAndZone && entrieProviceAndCityAndZone.map((item) => <MenuItem value={item.id} style={MenuItemStyle}>{item.name}</MenuItem>);
    const guildsItems = guilds && guilds.map((item) => <MenuItem value={item.id} style={MenuItemStyle}>{item.name}</MenuItem>);

    return (<>
        <form onSubmit={handleSubmit}>
            <div style={paperStyle} >
                <Grid align='center'>
                    <Badge
                        overlap="circular"
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        badgeContent={
                            <SmallAvatar onClick={openFileDialog}>
                                <PhotoCameraIcon />
                            </SmallAvatar>
                        }
                    >
                        <Avatar src={customerInformation.cdnImage} style={avatarStyle} />
                    </Badge>
                </Grid>
                <Typography variant="h6" gutterBottom>
                    مشخصات
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            style={formElementStyle}
                            className={classes.root}
                            required
                            id="firstName"
                            name="firstName"
                            label="نام"
                            fullWidth
                            variant="standard"
                            //value={name}
                            //onChange={handleFirstNameChange}
                            value={firstName}
                            onChange={e => setFirstName(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            style={formElementStyle}
                            className={classes.root}
                            required
                            id="lastName"
                            name="lastName"
                            label="نام خانوادگی"
                            fullWidth
                            variant="standard"
                            value={lastName}
                            onChange={e => setLastName(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <InputMask
                            mask="9999999999"
                            maskChar=" "
                            value={birthCertificateNumber}
                            onChange={e => setBirthCertificateNumber(e.target.value)}
                        >
                            {() => <TextField
                                style={formElementStyle}
                                className={classes.root}
                                id="birthCertificateNumber"
                                name="birthCertificateNumber"
                                label="شماره شناسنامه"
                                fullWidth
                                variant="standard" />}
                        </InputMask>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <InputMask
                            mask="9999999999"
                            maskChar=" "
                            value={nationalCode}
                            onChange={e => setNationalCode(e.target.value)}
                        >
                            {() => <TextField
                                style={formElementStyle}
                                className={classes.root}
                                id="nationalCode"
                                name="nationalCode"
                                label="کد ملی"
                                fullWidth
                                variant="standard" />}
                        </InputMask>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormLabel row component="legend" style={{ color: '#ffffff' }}>جنسیت</FormLabel>
                        <RadioGroup
                            row
                            aria-label="gender"
                            value={sex ? "female" : "male"}
                            name="radio-buttons-group"
                            onChange={e => setSex(e.target.value === "female")}
                        >
                            <FormControlLabel value="female" control={<CustomRadio />} label="زن" />
                            <FormControlLabel value="male" control={<CustomRadio />} label="مرد" />
                        </RadioGroup>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <LocalizationProvider dateAdapter={AdapterJalali}>
                            <DatePicker
                                mask="____/__/__"
                                value={birthDateValue}
                                onChange={e => setBirthDateValue(e)}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        style={formElementStyle}
                                        className={classes.root}
                                        id="birthDate"
                                        name="birthDate"
                                        label="تاریخ تولد"
                                        fullWidth
                                        variant="standard" />}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormLabel row component="legend" style={{ color: '#ffffff' }}>تاهل</FormLabel>
                        <RadioGroup
                            row
                            aria-label="isMarried"
                            value={isMarried ? "Married" : "NoMarried"}
                            name="radio-buttons-group"
                            onChange={e => setIsMarried(e.target.value === "Married")}
                        >
                            <FormControlLabel value="NoMarried" control={<CustomRadio />} label="مجرد" />
                            <FormControlLabel value="Married" control={<CustomRadio />} label="متاهل" />
                        </RadioGroup>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <LocalizationProvider dateAdapter={AdapterJalali}>
                            <DatePicker
                                mask="____/__/__"
                                value={dateOfMarriageValue}
                                onChange={e => setDateOfMarriageValue(e)}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        style={formElementStyle}
                                        className={classes.root}
                                        id="dateOfMarriage"
                                        name="dateOfMarriage"
                                        label="تاریخ ازدواج"
                                        fullWidth
                                        variant="standard" />}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <LocalizationProvider dateAdapter={AdapterJalali}>
                            <DatePicker
                                mask="____/__/__"
                                value={wifeOrHousbandBirthDateValue}
                                onChange={e => setWifeOrHousbandBirthDateValue(e)}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        style={formElementStyle}
                                        className={classes.root}
                                        id="wifeOrHousbandBirthDate"
                                        name="wifeOrHousbandBirthDate"
                                        label="تاریخ تولد همسر"
                                        fullWidth
                                        variant="standard" />}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormControl
                            variant="standard"
                            sx={{ m: 1, minWidth: 120 }}
                            fullWidth
                            style={{ ...formElementStyle, direction: 'rtl' }}
                            className={classes.root}>
                            <InputLabel id="demo-simple-select-filled-label">شغل</InputLabel>
                            <Select
                                labelId="demo-simple-select-filled-label"
                                id="demo-simple-select-filled"
                                value={guildId}
                                onChange={e => setGuildId(e.target.value)}
                            >
                                {guildsItems}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormControl
                            variant="standard"
                            sx={{ m: 1, minWidth: 120 }}
                            fullWidth
                            style={{ ...formElementStyle, direction: 'rtl' }}
                            className={classes.root}>
                            <InputLabel id="demo-simple-select-filled-label">استان</InputLabel>
                            <Select
                                labelId="demo-simple-select-filled-label"
                                id="demo-simple-select-filled"
                                value={provinceId}
                                onChange={e => setProvinceId(e.target.value)}
                            >
                                {provice}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormControl
                            variant="standard"
                            sx={{ m: 1, minWidth: 120 }}
                            fullWidth
                            style={{ ...formElementStyle, direction: 'rtl' }}
                            className={classes.root}>
                            <InputLabel id="demo-simple-select-filled-label">شهر</InputLabel>
                            <Select
                                labelId="demo-simple-select-filled-label"
                                id="demo-simple-select-filled"
                                value={cityId}
                                onChange={e => setCityId(e.target.value)}
                            >
                                {cities}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <InputMask
                            mask="9999999999"
                            maskChar=" "
                            value={postalCode}
                            onChange={e => setPostalCode(e.target.value)}
                        >
                            {() => <TextField
                                style={formElementStyle}
                                className={classes.root}
                                id="postalCode"
                                name="postalCode"
                                label="کد پستی"
                                fullWidth
                                variant="standard" />}
                        </InputMask>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <TextField
                            style={formElementStyle}
                            className={classes.root}
                            value={address}
                            onChange={e => setAddress(e.target.value)}
                            id="address"
                            name="address"
                            label="آدرس"
                            fullWidth
                            variant="standard" />
                    </Grid>
                    <div style={{height:'80px',width:'100%'}}></div>

                    <div style={footerButtonContainerStyle}>
                        <div style={footerButtonStyle}>
                            <Button
                                id="submit"
                                type='submit'
                                name="submit"
                                variant="contained"
                                color="success"
                                fullWidth
                                style={formButtonElementStyle}>ثبت</Button>
                        </div>
                        <div style={footerButtonStyle}>
                            <Button
                                onClick={() => { props.history.push('/') }}
                                id="cancel"
                                name="cancel"
                                variant="contained"
                                color="success"
                                fullWidth
                                style={formButtonElementStyle}>انصراف</Button>
                        </div>
                    </div>
                </Grid>
            </div>
        </form>
        <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
        <input type='file' id='file' accept="image/*" ref={inputFile} style={{ display: 'none' }} onChange={readAvatarFile} />
    </>
    );
}

export default withRouter(UserProfileForm);